import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { MdHome, MdPerson } from 'react-icons/md'
import { MdNotificationsNone } from 'react-icons/md'
import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'
import { GetRouteUrlByKeyTask } from '@/Core/Tasks/UI/Menu/GetRouteUrlByKeyTask'
import { useUnreadNotificationCount } from '@/Containers/CommunicationSection/NotificationContainer/Hooks/useUnreadNotificationCount'
import styles from './DriverBottomNavigation.module.css'

const NAV_ITEMS = [
    { key: 'Driver.Dashboard', icon: <MdHome />, label: 'Головна' },
    { key: 'Driver.Notifications', icon: <MdNotificationsNone />, label: 'Сповіщення' },
    { key: 'Driver.Profile', icon: <MdPerson />, label: 'Профіль' },
]

export const DriverBottomNavigation: React.FC = observer(() => {
    const navigate = useNavigate()
    const location = useLocation()
    const unreadCount = useUnreadNotificationCount()

    return (
        <nav className={styles['nav']} aria-label="Навігація водія" data-bottom-nav="64">
            {NAV_ITEMS.map(({ key, icon, label }) => {
                const url = GetRouteUrlByKeyTask(key)
                if (!url) return null

                const isActive = location.pathname === url

                const iconEl = key === 'Driver.Notifications'
                    ? (
                        <Badge
                            count={unreadCount}
                            overflowCount={99}
                            size="small"
                            classNames={{ indicator: styles['indicator'] as string }}
                        >
                            <span className={styles['icon']}>{icon}</span>
                        </Badge>
                    )
                    : <span className={styles['icon']}>{icon}</span>

                return (
                    <button
                        key={key}
                        className={`${styles['tab']}${isActive ? ` ${styles['tabActive']}` : ''}`}
                        onClick={() => navigate(url)}
                        aria-label={label}
                        aria-current={isActive ? 'page' : undefined}
                    >
                        <span className={styles['iconWrap']}>
                            {iconEl}
                        </span>
                        <span className={styles['label']}>{label}</span>
                    </button>
                )
            })}
        </nav>
    )
})

DriverBottomNavigation.displayName = 'DriverBottomNavigation'
